import React, { forwardRef, Fragment, useRef } from "react";
import { Button, Table, TableBody, TableHead, TableRow } from "@mui/material";
import TableCell from '@mui/material/TableCell';
import { Print } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";

/*------------- Function Component to be called by ToPrintPageBookTestDate-----------*/
const ComponentToPrint = forwardRef((props, ref) => {
    const { dataToPrint } = props;

    /*------------------- RETURN ---------------------------*/
    return (
        <div ref={ref} >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={5} align='center'>
                            <div style={{ fontSize: 20, fontWeight: 'bold' }}>
                                รายการชื่อผู้เข้าสอบห้องสอบ {dataToPrint.labroom.toUpperCase()}
                            </div>
                        </TableCell>
                    </TableRow>
                    {/*-------------- Date & Time -----------------*/}
                    <TableRow>
                        <TableCell colSpan={5} align='center'>
                            <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                วันทดสอบ {dataToPrint.thdate}&emsp;เวลาทดสอบ {dataToPrint.time}
                            </div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                ลำดับ
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                รหัสการจอง
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                เลขประจำตัว
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                ยศ ชื่อ นามสกุล
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                แบบทดสอบ
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                ฟอร์มทดสอบ
                            </div>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        dataToPrint['rows']?.map((r, i) => {
                            return (
                                <TableRow key={i}>
                                    <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                        {r.id}
                                    </TableCell>
                                    <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                        {r.resvcode}
                                    </TableCell>
                                    <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                        {r.idnumber}
                                    </TableCell>
                                    <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                        {r.name}
                                    </TableCell>
                                    <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                        {r.type}
                                    </TableCell>
                                    <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                        {r.form}
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </div >
    );
});

/*------------- Function Component to be called as child component -----------*/
const ToPrintPageAdditionalExammanagement = (props) => {
    const { toprint } = props;
    const componentRef = useRef();

    const marginTop = '1cm';
    const marginRight = '0.5cm';
    const marginBottom = '1cm';
    const marginLeft = '0.5cm';

    const getPageMargin = () => {
        return (`
            @page {
                size: A4 landscape;
                margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;
            }
        `);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: getPageMargin()
    });

    return (
        <Fragment>
            <div style={{ display: 'none' }}>
                <ComponentToPrint ref={componentRef} dataToPrint={toprint} />
            </div>
            <Button
                variant={'contained'}
                endIcon={<Print />}
                onClick={
                    handlePrint
                }
                sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    width: 200, padding: 1, margin: 2
                }}
            >
                พิมพ์
            </Button>
        </Fragment>

    );
}

export default ToPrintPageAdditionalExammanagement;